import { render } from "./ProfileT2View.vue?vue&type=template&id=089393b3&scoped=true"
import script from "./ProfileT2View.vue?vue&type=script&lang=js"
export * from "./ProfileT2View.vue?vue&type=script&lang=js"

import "./ProfileT2View.vue?vue&type=style&index=0&id=089393b3&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-089393b3"]])

export default __exports__